import useApi from '@/hooks/useApi';
import React, { useEffect, useRef, useState } from 'react';
import OnboardingDismissButton from './OnboardingDismissButton';
import OnboardingTabBar from './OnboardingTabBar';
import OnboardingTabPanel from './OnboardingTabPanel';

interface OnboardingTab {
    id: number;
    title: string;
    description?: string | null;
    video_url?: string | null;
    vimeo_url?: string | null;
}

export interface OnboardingData {
    id: number;
    grace_days: number;
    tabs: OnboardingTab[];
    has_visibility_record: boolean;
    is_visible: boolean;
}

interface Props {
    onboarding: OnboardingData;
    onDismiss: () => void;
}

const OnboardingSection: React.FC<Props> = ({ onboarding, onDismiss }) => {
    const [activeTabIndex, setActiveTabIndex] = useState(0);
    const api = useApi();
    const recordedRef = useRef(false);

    useEffect(() => {
        if (!onboarding.has_visibility_record && !recordedRef.current) {
            recordedRef.current = true;
            api.post('/onboarding/record-view/');
        }
    }, [onboarding.has_visibility_record]);

    if (onboarding.tabs.length === 0) {
        return null;
    }

    const handleDismiss = () => {
        onDismiss();
    };

    const activeTab = onboarding.tabs[activeTabIndex];

    return (
        <div className="rounded-lg border border-gray-200 bg-white p-6 shadow-sm">
            <div className="mb-4 flex items-center justify-between">
                <OnboardingTabBar
                    tabs={onboarding.tabs}
                    activeIndex={activeTabIndex}
                    onTabChange={setActiveTabIndex}
                />
                <div className="ml-4 flex-shrink-0">
                    <OnboardingDismissButton onDismiss={handleDismiss} />
                </div>
            </div>
            <OnboardingTabPanel tab={activeTab} />
        </div>
    );
};

export default OnboardingSection;
